<div class="normalScreen" style="background:white">
  <form [formGroup]="searchForm" (ngSubmit)="search()">
    <div formGroupName="date">
      <div style="margin-left:10px;margin-top:10px">
        <mat-form-field>
          <input matInput [matDatepicker]="fromDate" [max]="maxDate" placeholder="Från" formControlName="from">
          <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
          <mat-datepicker #fromDate></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
          <input matInput [matDatepicker]="toDate" [max]="maxDate" placeholder="Till" formControlName="to">
          <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
          <mat-datepicker #toDate></mat-datepicker>
        </mat-form-field>
      </div>
      <div style="margin-left:10px" *ngIf="!dateGroup.valid && dateGroup.errors?.range" class="cross-validation-error-message alert alert-danger">
        <label>Från måste vara tidigare än till.</label>
      </div>
    </div>
    <div>

      <button mat-flat-button color="primary" data-cy="searchInvoice" type="submit" style="margin-left:10px;background:#7AB800" [disabled]="!canSearch()">Sök</button>
      <button mat-flat-button color="primary" data-cy="exportInvoice" type="button" (click)="exportReport()" style="margin-left:10px;background:#7AB800" [disabled]="!canExport()">Exportera till Excel</button>
    </div>
  </form>
  <div>
    <ngx-spinner #spinner [config]="spinnerConfig">
    </ngx-spinner>
    <div style="margin-left:10px;position:relative" width="1600" height="750">
      <div>
        <ag-grid-angular style="width:1600px;height:750px;margin-left:10px;margin-top:10px"
                         #agGrid
                         dom vi class="ag-theme-material"
                         [gridOptions] ="gridOptions"
                         [rowData]="invoiceRowData">
        </ag-grid-angular>
      </div>
    </div>
  </div>
</div>
